import { Controller, UseFormReturn } from 'react-hook-form'
import { Connection } from 'features/connections'
import { Box, Checkbox, FormControl, FormControlLabel } from '@mui/material'
import { useIntl } from 'react-intl'
import { Link, Typography } from '@carto/meridian-ds/components'
import { NavLink } from 'react-router-dom'

interface QueryAliasOnlyProps {
  form: Omit<UseFormReturn, 'handleSubmit' | 'formState'>
  connection?: Connection
}

function QueryAliasOnly({ form, connection }: QueryAliasOnlyProps) {
  const intl = useIntl()
  const { control } = form

  return (
    <FormControl>
      <Box ml={0.3}>
        <Controller
          name="namedSourcesOnly"
          control={control}
          defaultValue={connection?.namedSourcesOnly || false}
          render={({ field }) => (
            <FormControlLabel
              label={intl.formatMessage({ id: 'connections.create.advanced.developerOptions.namedSourcesOnly.title' })}
              control={<Checkbox {...field} checked={field.value} />}
            />
          )}
        />
      </Box>
      <Typography mt={1} variant="caption" color="textSecondary">
        {intl.formatMessage(
          { id: 'connections.create.advanced.developerOptions.namedSourcesOnly.description' },
          {
            link: (content: React.ReactNode) => (
              <Link component={NavLink} to="/developers/named-sources">
                {content}
              </Link>
            )
          }
        )}
      </Typography>
    </FormControl>
  )
}

export default QueryAliasOnly
